import type { BizIconProps } from './base';
import BizIconSvg from './base';

/**
 * IconTranscript — 转写：圆角文本卡 + 三条文本行，表达语音转写的文字记录
 * （icon-map.md §3.2 ⑤；16px 下以文本行表达"引语/记录"语义，圆点/引号细节省略）。
 */
export default function IconTranscript(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <rect x="2.9" y="2.9" width="10.2" height="10.2" rx="2" />
      <path d="M5.4 5.6h5.8" />
      <path d="M5.4 8h5.8" />
      <path d="M5.4 10.4h3.4" />
    </BizIconSvg>
  );
}
